var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgProfile = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10.005 20C15.472 20 20 15.472 20 9.995 20 4.528 15.462 0 9.995 0 4.528 0 0 4.528 0 9.995 0 15.472 4.538 20 10.005 20zm6.096-4.466c-1-1.166-3.218-2.197-6.096-2.197S4.91 14.368 3.91 15.523C2.59 14.07 1.795 12.13 1.795 9.995c0-4.56 3.64-8.22 8.2-8.22 4.559 0 8.22 3.66 8.23 8.22 0 2.135-.804 4.074-2.124 5.539zm-6.096-3.837c1.877.02 3.352-1.589 3.352-3.683 0-1.97-1.485-3.61-3.352-3.61-1.877 0-3.362 1.64-3.352 3.61.01 2.094 1.465 3.672 3.352 3.683z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgProfile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/_profile.fb8b61ce.svg";
export { ForwardRef as ReactComponent };